import React, { useState, useEffect } from 'react'

import { ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native'

import { Title, Text, Space, MenuList, HorizontalLine } from '@sart/components'
import { adaptive, colors, typography } from '@sart/styles'
import client, { useData } from '@sart/client'
import { getLanguageCode } from '@sart/utilities'
import { testID } from '@sart/utilities'
import Accordion  from 'react-native-collapsible/Accordion';

export default function FAQs(props) {
  const { navigation } = props

  const [activeSections, setActiveSections] = useState([])

  const [{ FAQItems, error, loading }, setData] = useData({})

  const items = React.useMemo(() => FAQItems)

  useEffect(() => {
    getFAQItems()
  }, [client.cache.language])
  // console.log('client.cache.language is: ');
  // console.log(client.cache.language);

  var language = getLanguageCode(client.cache.language)

  function flatMap(array, fn) {
    var result = [];
    for (var i = 0; i < array.length; i++) {
      var mapping = fn(array[i]);
      result = result.concat(mapping);
    }
    return result;
  }

  async function getFAQItems() {
    setData({ loading: true })
    try {
      const FAQItems =  await client.callApi('contentCms','getPages',[1, { category: "FAQ", lang: language }]); 
      const parsedItems = FAQItems.map(item => {
        let excerpt = {}
        try {
          excerpt = JSON.parse(item.excerpt)

        } catch(error) {
          return {}
        }
        // let excerpt = JSON.parse(item.excerpt)
        // let content = JSON.parse(item.excerpt)
        let parsed = {};
        parsed.rank = excerpt.rank;
        parsed.title = excerpt.title;
        if (excerpt.description.includes("Consúltala aquí")) {
          excerpt.description = flatMap(excerpt.description.split(/Consúltala aquí/g), function (part) {
            return [part, <Text onPress={() => window.open("https://exis.mx/files/datacalc/sliders.html", '_blank')} style={{color: 'blue'}}>Consúltala aquí</Text>]
          })
          excerpt.description.pop();
          parsed.content = excerpt.description
        } else if (excerpt.description.includes("Consulta el estatus de tu trámite")) {
          excerpt.description = flatMap(excerpt.description.split(/Consulta el estatus de tu trámite/g), function (part) {
            return [part, <Text onPress={() => window.open("https://portabilidad.mx/", '_blank')} style={{color: 'blue'}}>Consulta el estatus de tu trámite</Text>]
          })
          excerpt.description.pop();
          parsed.content = excerpt.description
        } else {
          parsed.content = excerpt.description;
        }        
        return parsed;
      });
      const orderedItems = parsedItems.sort(function(a,b) {
        return a.rank - b.rank;
      })
      setData({
        FAQItems: orderedItems,
        loading: false
      })
      client.setCache({
        FAQItems: orderedItems
      })
    } catch (error) {
      // TODO: handle error
      setData({ loading: true, error })
    }
  }

  var _renderHeader = section => {
    return (
      <View style={styles.header}>
        <View style={{flexDirection: 'row'}}>
          {activeSections.length ==  0 &&
            <Text style={styles.bulletPoint}>+</Text>
          }
          {activeSections.length ==  1 &&
            <Text style={styles.bulletPoint}>-</Text>
          }
          <Space width={5} height={5} />
          <Text style={styles.headerText} {...testID(section.title)}>{section.title}</Text>
        </View>
        <Space height={20} />
      </View>
    );
  };

  var _renderContent = section => {
    return (
      <View style={styles.content}>
        <Text style={styles.contentText}>{section.content}</Text>
        <Space height={10} />
        <HorizontalLine height={1} color={colors.srGreen} />
        <Space height={10} />
      </View>
    );
  };

  var _updateSections = activeSections => {
    setActiveSections(activeSections);
  };

  return (
    <ScrollView style={styles.wrapper}>
    {FAQItems &&
      <Accordion
        sections={FAQItems}
        activeSections={activeSections}
        renderHeader={_renderHeader}
        renderContent={_renderContent}
        onChange={_updateSections}
        underlayColor={colors.clear}	
      />
      }
    <Space height={24} />
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    paddingTop: 24,
    paddingBottom: 24,
    ...adaptive.wrapperPadding,
  },
  titleText: {
    textAlign: 'center',
    ...typography.demi,
    fontSize: 16
  },
  headerText: {
    ...typography.bold
  },
  contentText: {
    ...typography.book
  },
  bulletPoint: {
    color: colors.srDarkGreen,
    ...typography.bold
  }
})
